import React from "react";
import { AddButton, PaginationStyle, TableStyle } from "../../components/styles/MainLayout";
import { CardStyle } from "../../components/styles/MainLayoutResponsive"
import axios from "../../axios";
import { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { connect } from "react-redux";
import { setSideBar } from "../../redux/Functions/actions";
import { Link, useParams } from "react-router-dom";
import SearchInputHeader from "../../components/form/SearchInputHeader";
import DeleteModal from "./modals/deleteModal";
import EditGenderModal from "./modals/modal";



const Genders = (props) => {
    const { id } = useParams();
    const [dataToModal, setDataToModal] = useState(null);


    //AXIOS API's
    const [allSalons, setAllSalons] = useState([])
    const getData = () => {
        axios.get('/api/admin/genders/all')
            .then(data => {
                console.log('allusers get req', data.data);
                setAllSalons(data.data)
            }).catch(err => console.log(err));
    }


    ///axios
    const [Membership, setMembership] = useState([])
    const getMembership = () => {
        axios
            .get("/api/admin/subscriptions/all")
            .then((response) => {
                console.log("olaLabels", response.data);
                setMembership(response.data)

            }).catch(err => {
                console.log(err)
            })
    }
    const [owners, setOwners] = useState([])
    const getOwners = () => {
        axios.get("/api/admin/users/activeStoreAdmins").then(
            data => {
                console.log("api users", data.data)
                setOwners(data.data)
            }
        ).catch(err => {
            console.log(err)
        })
    }
    useEffect(() => {
        getOwners()
        getData()
        getMembership()
    }, [])
    //MODAL STATES
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenDelete, setIsOpenDelete] = useState(false);
    const [singleUserData, setSingleUserData] = useState({})
    const [modalType, setModalType] = useState(null);
    //MODAL STATES

    //MODAL HANDLERS
    const handleModalAdd = () => {
        setIsOpen(true);
        setModalType("add");

    };

    const handleModalEdit = (data) => {
        setIsOpen(true);
        setModalType("edit");
        setSingleUserData(data);
    };
    const handleModalClose = () => {
        setIsOpen(false);
        setIsOpenDelete(false);
    }

    const handleModalDelete = (data) => {
        setIsOpenDelete(true);
        setModalType("delete");
        setDataToModal(data)
    }
  


    //MODAL HANDLERS

    const [viewportSize, setViewportSize] = useState(window.innerWidth); //DESKTOP VIEW & MOBILE VIEW

    //PAGINATION
    const [currentPage, setCurrentPage] = useState(false);
    const startIndex = currentPage * 7;
    const endIndex = startIndex + 7;
    const numPages = Math?.ceil(allSalons?.length / 7)

    const data = allSalons?.slice(startIndex, endIndex);

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };


    window.addEventListener("resize", () => {
        setViewportSize(window.innerWidth);
    });
    console.log('owners', owners)
    console.log("sallonet", allSalons)
    if (viewportSize > 800)
        return (
            <>
                <SearchInputHeader />
                {isOpen === true ? (
                    <EditGenderModal
                        getNewSalon={getData}
                        isOpen={isOpen}
                        type={modalType}
                        dataToModal={singleUserData}
                        handleModalClose={handleModalClose}
                    />
                ) : (
                    ""
                )}
                {isOpenDelete === true ? (
                    <DeleteModal
                        getNewSalon={() => getData()}
                        isOpen={isOpenDelete}
                        type={modalType}
                        dataToModal={dataToModal}
                        handleModalClose={handleModalClose}
                    />
                ) : (
                    ""
                )}
                <TableStyle collapse={props?.sidebar}>
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                {/* <th scope="col-1">ID</th> */}
                                <th scope="col-4">Gjinia SHQ</th>
                                <th scope="col-4">Gender ENG</th>
                                <th scope="col-4 pl-2" style={{ textAlign: "end" }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.map((el) => {
                                //CREATED AT FORMAT TO DATE MONTH YEAR ONLY
                                const date = new Date(el?.created_at)
                                const formatDate = date?.toLocaleDateString()

                                return (
                                    <>
                                        <tr>
                                            {/* <th scope="row" className="col-1">
                                                {el?.id}
                                            </th> */}
                                            <td className="col-4">{el?.name_al}</td>
                                            <td className="col-4">{el?.name_en}</td>
                                            <td className="col-4">
                                                <div className="d-flex justify-content-end  gap-3">
                                              
                                                    {/* <i class="fa-regular fa-eye mt-1  iconsForCursor" onClick={() => handleModalView(el)} /> */}
                                                    <i class="fa-regular fa-pen-to-square mt-1 iconsForCursor" onClick={() => handleModalEdit(el)} />
                                                    <i class="fa-regular fa-trash-can  mt-1 iconsForCursor" onClick={() => handleModalDelete(el)} />
                                                </div>
                                            </td>
                                        </tr>
                                    </>
                                );
                            })}
                        </tbody>
                    </table>
                </TableStyle>
                <PaginationStyle collapse={props?.sidebar}>
                    <ReactPaginate
                        previousLabel={"previous"}
                        nextLabel={"next"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={numPages}
                        onPageChange={handlePageChange}
                        containerClassName={"pagination justify-content-center"}
                        activeClassName={"active"}
                        currentPage={allSalons?.length > 7 ? true : false}
                    />
                </PaginationStyle>
                    <AddButton onClick={() => handleModalAdd()}>
                        <i type={"button"} className="fa-solid fa-circle-plus fa-xl iconsForCursor" style={{ color: "#FF5758" }}></i>
                    </AddButton>
            </>
        )
    else {
        return (
            <>
                <SearchInputHeader />
                {isOpen === true ? (
                    <EditGenderModal
                        getNewSalon={getData}
                        isOpen={isOpen}
                        type={modalType}
                        dataToModal={singleUserData}
                        handleModalClose={handleModalClose}
                    />
                ) : (
                    ""
                )}
                {isOpenDelete === true ? (
                    <DeleteModal
                        getNewSalon={() => getData()}
                        isOpen={isOpenDelete}
                        type={modalType}
                        dataToModal={dataToModal}
                        handleModalClose={handleModalClose}
                    />
                ) : (
                    ""
                )}
                <div className="container">
                    {data?.map((el) => {
                        //CREATED AT FORMAT TO DATE MONTH YEAR ONLY
                        const date = new Date(el?.created_at)
                        const formatDate = date?.toLocaleDateString()
                        return (
                            <>
                                <CardStyle>
                                    <div className="mb-3">
                                        <div className="row">
                                            <div className="col-8">
                                                <ul className="list-group gap-3 pt-2 pb-2 ps-3">
                                                    <li class="list-group"><span><strong>Gjinia SHQ</strong>: {el.name_al}</span></li>
                                                    <li class="list-group"><span><strong>Gjinia ENG</strong>: {el.name_en}</span></li>
                                                </ul>
                                            </div>
                                            <div className="col-3 pt-2">
                                                <div className="d-flex gap-2">
                                                <i class="fa-regular fa-pen-to-square mt-1 iconsForCursor" onClick={() => handleModalEdit(el)} />
                                                    <i class="fa-regular fa-trash-can  mt-1 iconsForCursor" onClick={() => handleModalDelete(el)} />
                                                 </div>
                                            </div>
                                        </div>
                                    </div>

                                </CardStyle>
                            </>
                        )
                    })}
                        <AddButton onClick={() => handleModalAdd()}>
                            <i type={"button"} className="fa-solid fa-circle-plus fa-xl iconsForCursor" style={{ color: "#FF5758" }}></i>
                        </AddButton>
                    
                </div>
            </>
        )

    }
}
// export default SalonTable
const mapStateToProps = (state) => {
    return {
        selected_lang: state.data.selected_lang,
        logged_in: state.data.logged_in,
        sidebar: state?.data?.sidebar,
        dataFilter: state?.data?.dataFilter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSideBar: (data) => dispatch(setSideBar(data)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Genders);